export const GET_ACCOUNT_FANS = {
  LOADING: 'getAccountFansLoading',
  SUCCESS: 'getAccountFansSuccess',
  FAIL: 'getAccountFansFail'
};

export const GET_ACCOUNT_FOLLOWINGS = {
  LOADING: 'getAccountFollowingsLoading',
  SUCCESS: 'getAccountFollowingsSuccess',
  FAIL: 'getAccountFollowingsFail'
};

export const SET_FOLLOWING = {
  LOADING: 'setFollowingLoading',
  SUCCESS: 'setFollowingSuccess',
  FAIL: 'setFollowingFail'
};
